import Vue from 'vue';
import Router from 'vue-router';
import HomeView from '@/views/Home';
import ProjectsView from '@/views/Projects';
import ProjectView from '@/views/Project';
// import ContactView from '@/views/Contact';
import p404View from '@/views/p404';

Vue.use(Router);

/**
 * Creates the router for the application
 * @return {Router}
 */
export function createRouter() {
  return new Router({
    mode: 'history',
    routes: [
      {
        path: '/',
        name: 'Home',
        component: HomeView
      },
      {
        path: '/project/:urlPostFix',
        name: 'project',
        component: ProjectView,
        meta: {reuse: false}
      },
      {
        path: '/projects',
        name: 'Projects',
        component: ProjectsView
      },
      // {
      //   path: '/contact',
      //   name: 'Contact',
      //   component: ContactView
      // },
      // 404 catch all, should be at the bottom.
      {
        path: '*',
        name: '404',
        component: p404View
      }
    ],
    scrollBehavior(to, from, savedPosition) {
      if (savedPosition) {
        return savedPosition;
      }
      return { x: 0, y: 0 };
    }
  });
}



// WEBPACK FOOTER //
// ./src/router/index.js